import React from "react";
import { Col, Row } from "reactstrap";
import CheckboxField from "src/components/Form/CheckboxFieldV2/CheckboxFieldV2";
import NumberField from "src/components/Form/NumberFormatFieldV2/NumberFormatFieldV2";
import TextField from "src/components/Form/TextFieldV2/TextFieldV2";
import TypeaheadField from "src/components/Form/TypeaheadFieldV2/TypeaheadFieldV2";
import * as S from "src/constants/StringConstants";

const ProductPolicyForm = ({ productDetails }) => {
  return (
    <div style={{ minWidth: "270px" }}>
      <Row>
        <Row>
          <Col sm="10" className="app-form-header">
            <h4 className="form-title">{S.APP_PRODUCT_DETAIL_POLICY_TITLE}</h4>
          </Col>
        </Row>

        <Row>
          <Col sm="10">
            <NumberField
              name="monthlyBenefit"
              label={S.APP_PRODUCT_FIELD_MONTHLY_BENEFIT}
              prefix="$"
              thousandSeparator={true}
              decimalScale={2}
            />
          </Col>
        </Row>

        <Row>
          <Col sm="10">
            <TypeaheadField
              name="eliminationPeriodTypeID"
              label={S.APP_PRODUCT_FIELD_ELIMINATION_PERIOD}
              options={productDetails?.selectEliminationPeriodTypeList}
            />
          </Col>
        </Row>

        <Row>
          <Col sm="10">
            <TypeaheadField
              name="benefitPeriodTypeID"
              label={S.APP_PRODUCT_FIELD_BENEFIT_PERIOD}
              options={productDetails?.selectBenefitPeriodTypeList}
            />
          </Col>
        </Row>

        <Row>
          <Col sm="10">
            <TextField name="baseBenefit" label={S.APP_PRODUCT_FIELD_BASE_BENEFIT} />
          </Col>
        </Row>

        <Row>
          <Col sm="10">
            <TextField name="socialOffset" label={S.APP_PRODUCT_FIELD_SOCIAL_OFFSET} />
          </Col>
        </Row>

        <Row>
          <Col sm="10">
            <NumberField
              name="lumpsumBenefit"
              label={S.APP_PRODUCT_FIELD_LUMP_SUM}
              prefix="$"
              thousandSeparator={true}
              decimalScale={2}
            />
          </Col>
        </Row>

        <Row>
          <Col sm="10">
            <CheckboxField name="increaseOption" label={S.APP_PRODUCT_FIELD_IO} labelPosition="above" />
          </Col>
        </Row>
      </Row>
    </div>
  );
};

export default ProductPolicyForm;
